
import { Badge } from "@/components/ui/badge";
import EnhancedSearchBar from "@/components/ui/EnhancedSearchBar";
import type { Category } from "@/services/promptService";

interface SearchHeaderProps {
  onSearch: (query: string) => void;
  searchQuery: string;
  categories: Category[];
  selectedCategory: string;
  onCategoryFilter: (categoryId: string) => void;
  suggestions?: string[];
  searchHistory?: string[];
  isLoadingSuggestions?: boolean;
  isSearching?: boolean;
  resultsCount?: number;
}

const SearchHeader = ({
  onSearch,
  searchQuery,
  categories,
  selectedCategory,
  onCategoryFilter,
  suggestions = [],
  searchHistory = [],
  isLoadingSuggestions = false,
  isSearching = false,
  resultsCount
}: SearchHeaderProps) => {
  return (
    <header className="mb-10">
      <h1 className="text-3xl font-bold mb-6">Search Prompts</h1>
      
      <EnhancedSearchBar 
        onSearch={onSearch} 
        initialValue={searchQuery}
        placeholder="Search by keyword, title, or description..."
        className="mb-8"
        suggestions={suggestions}
        searchHistory={searchHistory}
        isLoadingSuggestions={isLoadingSuggestions}
        isSearching={isSearching}
        resultsCount={resultsCount}
        showSuggestions={true}
      />
      
      {/* Category Filters */}
      <div className="flex flex-wrap gap-2 mb-8">
        {categories.map(category => (
          <Badge
            key={category.id}
            variant={selectedCategory === category.id ? "default" : "outline"}
            className="px-3 py-1 cursor-pointer hover:scale-105 transition-transform"
            onClick={() => onCategoryFilter(category.id)}
          >
            {category.name}
          </Badge>
        ))}
      </div>
    </header>
  );
};

export default SearchHeader;
